import React from 'react';
import { Box, Container, Typography, Grid, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';

const PROBLEMS = [
  'Reajustes frequentes',
  'Mensalidades cada vez maiores',
  'Dificuldade para comparar opções',
  'Falta de orientação especializada',
  'Coberturas que não acompanham suas necessidades',
];

const ProblemaSection: React.FC = () => {
  return (
    <Box component="section" sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="flex-start">
          <Grid item xs={12} md={5}>
            <Box
              component={motion.div}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5 }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '0.8rem',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  color: 'secondary.dark',
                  mb: 1.5,
                }}
              >
                O cenário atual
              </Typography>
              <Typography variant="h2" sx={{ fontSize: { xs: '1.75rem', md: '2.1rem' }, mb: 2.5 }}>
                Você sente que está pagando demais pelo seu plano de saúde?
              </Typography>
              <Typography sx={{ color: 'text.secondary', fontSize: '1rem', lineHeight: 1.7, mb: 4 }}>
                Muitos médicos e clínicas convivem com reajustes ano após ano sem nunca avaliar
                se existem opções mais adequadas ao seu perfil e à sua realidade.
              </Typography>

              <Stack direction="row" spacing={1.5} alignItems="center" sx={{ color: 'primary.main' }}>
                <ArrowDownwardRoundedIcon sx={{ fontSize: 20 }} />
                <Typography sx={{ fontWeight: 600, fontSize: '0.95rem' }}>
                  Existe um caminho mais inteligente. Veja como.
                </Typography>
              </Stack>
            </Box>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack spacing={2}>
              {PROBLEMS.map((problem, index) => (
                <Box
                  key={problem}
                  component={motion.div}
                  initial={{ opacity: 0, x: 24 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.4, delay: index * 0.07 }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 2.5,
                    bgcolor: 'background.paper',
                    borderRadius: '14px',
                    border: '1px solid',
                    borderColor: 'divider',
                  }}
                >
                  <Box
                    sx={{
                      width: 36,
                      height: 36,
                      borderRadius: '10px',
                      bgcolor: 'rgba(45, 212, 191, 0.14)',
                      color: 'secondary.dark',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <PriorityHighRoundedIcon sx={{ fontSize: 18 }} />
                  </Box>
                  <Typography sx={{ fontWeight: 500, color: 'text.primary' }}>{problem}</Typography>
                </Box>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ProblemaSection;
